import { Component, Input, OnDestroy } from '@angular/core';
import { IBreadcrumb } from '@app/models/beadcrumb/breadcrumb.model';
import { TerminologyService } from '@app/services/terminology/terminology.service';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    standalone: false
})
export class BreadcrumbsComponent implements OnDestroy {

  @Input() breadcrumbItems: ReadonlyArray<IBreadcrumb>;

  constructor(private terminologyService: TerminologyService) {
  }

  displayLabel(item: IBreadcrumb): string {
    return item.termKey ? this.terminologyService.get(item.termKey) + (item.labelSuffix ?? '') : item.label;
  }

  ngOnDestroy() {
  }


}


